import { Routes } from '@angular/router';
import { BasicComponent } from './common/layouts/basic/basic.component';
import { HomeComponent } from './views/home/home.component';
import { VoucherCovidListComponent } from './views/voucher-covid/voucher-covid-list/voucher-covid-list.component';
import { VoucherCovidManageComponent } from './views/voucher-covid/voucher-covid-manage/voucher-covid-manage.component';
import { TransportBonusListComponent } from './views/transport-bonus/transport-bonus-list/transport-bonus-list.component';
import { ServicePayPaymentMethodsListComponent } from './views/service-pay/payment-methods-list/service-pay-payment-methods-list.component';

export const ROUTES: Routes = [
  // Main redirect
  {path: '', redirectTo: 'home', pathMatch: 'full'}, //VA FATTA UNA 404??

  // App views
 /* {
    path: '', component: BlankComponent,
    children: [
      { path: 'test1', component: OrderEditComponent },
      { path: 'test1/:id', component: OrderEditComponent },
      { path: 'test2', component: OrdersListComponent },
      { path: 'test3/:id', component: SupplierDetailsComponent}
    ]
  }, */
  {
    path: '', component: BasicComponent,
    children: [
      { path: 'home', component: HomeComponent },
      // { path: 'voucher-covid/:token/:user/:language', component: VoucherCovidListComponent},
      // { path: 'voucher-covid/list', component: VoucherCovidListComponent},
      // { path: 'voucher-covid/manage', component: VoucherCovidManageComponent},
      { path: 'transport-bonus/:token/:user/:language', component: TransportBonusListComponent},
      { path: 'transport-bonus/list', component: TransportBonusListComponent},
      { path: 'service-pay/payment-methods/:token/:user/:language', component: ServicePayPaymentMethodsListComponent},
      { path: 'service-pay/payment-methods/list', component: ServicePayPaymentMethodsListComponent}
    ]
  },
  // Handle all other routes
  {path: '**',  redirectTo: 'home', pathMatch: 'full' }
] ;



// WEBPACK FOOTER //
// ./src/app/app.routes.ts